export const NOT_SELECTED_TEXT = 'common.NotSelected';
export const NOT_SELECTED_VALUE = null;
